module.exports = __webpack_public_path__ + "img/mapping_img.55c4f8a9.png";